
async function apiRequest(endpoint, method, body = {}) {
    try {
        const response = await fetch(`https://cartouches-proxy-server.onrender.com/wishlist/${endpoint}`, {
            method,
            headers: {
                'Content-Type': 'application/json',
            },
            body: method !== 'GET' ? JSON.stringify(body) : null,
        });
        const data = await response.json();
        if (!response.ok) {
            console.error('Erreur HTTP:', data);
            return { success: false, message: data.message || 'Erreur inconnue' };
        }
        return data.success ? data : { success: false, message: 'Opération échouée' };
    } catch (error) {
        console.error('Erreur réseau:', error);
        return { success: false, message: 'Erreur réseau' };
    }
}

async function getUser(searchTerm) {
    return await apiRequest('search-user', 'POST', { searchTerm });
}

async function getGroups(customerId, email, name, phone) {
    return await apiRequest('groups', 'POST', { customerId, email, name, phone });
}

async function getGroupFavorites(customerId, groupId) {
    return await apiRequest('group-favorites', 'POST', { customerId, groupId });
}

async function addToWishlist(customerId, groupId, productId, productHandle, brand, model) {
    return await apiRequest('add', 'POST', { customerId, groupId, productId, productHandle, brand, model });
}

async function removeFromAllGroups(customerId, productId) {
    return await apiRequest('remove', 'POST', { customerId, productId });
}

async function removeFromGroup(customerId, groupId, productId) {
    return await apiRequest('remove-from-wishlist', 'POST', { customerId, groupId, productId });
}

async function createGroup(customerId, groupId) {
    return await apiRequest('create-group', 'POST', { customerId, groupId });
}

async function deleteGroup(customerId, groupId) {
    return await apiRequest('delete-group', 'POST', { customerId, groupId });
}

document.addEventListener('alpine:init', () => {
    const printerContainerEl = document.querySelector('#printer-products-container');
    const otherContainerEl = document.querySelector('#other-products-container');
    const groupNavigationContainer = document.querySelector('#group-navigation-container');
    const favoritesView = 'favorites';
    const compatibleView = 'printer-compatibles';
    const customerId = window.customerData?.customerId || null;
    const email = window.customerData?.email || '';
    const name = window.customerData?.name || '';
    const phone = window.customerData?.phone || '';
    console.log(customerId, email, name, phone)

    const currentPage = window.location.pathname;
    Alpine.store('wishlist', {
        customerId: customerId,
        email: email,
        name: name,
        phone: phone,
        printerContainerEl: printerContainerEl,
        otherContainerEl: otherContainerEl,
        favoritesView: favoritesView,
        compatibleView: compatibleView,
        groupToAdd: '',
        selectedGroup: '',
        navigationLinks: this.navigationLinks || [],
        groupId: new URLSearchParams(window.location.search).get('groupId') || null,
        groups: this.groups || [],
        favorites: this.favorites || new Map(),
        modals: {
            createGroup: false,
            addFavorite: false
        },
        searchTerm: '',
        searchResults: [],
        selectedUser: null,

        async searchUser() {
            if (this.searchTerm.length > 0) {
                const result = await getUser(this.searchTerm)
                if (result.success) {
                    this.searchResults = result.user ? [result.user] : [];
                } else {
                    console.error('Erreur de recherche', result.message);
                    this.searchResults = [];
                }
            }
        },

        selectUser(user) {
            this.selectedUser = user;
            window.customerData = {
                customerId: user.customerId,
                email: user.email,
                name: user.name,
                phone: user.phone,
            };
            this.searchTerm = '';
            this.searchResults = [];
            localStorage.setItem('customerData', JSON.stringify(window.customerData));

            this.init();
        },

        checkAuth() {
            if (!this.customerId && (currentPage.includes('wishlist') || currentPage.includes('wishlist-group'))) {
                const returnUrl = encodeURIComponent(currentPage);
                window.location.href = `/account/login?return_url=${returnUrl}`;
            }
            return !!this.customerId;
        },

        denormalizeGroupName(groupId) {
            return groupId ? groupId.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()) : 'Groupe inconnu';
        },

        scrollToProduct(productId) {
            let target;
            const offset = window.innerHeight / 3;
            target = productId ? this.printerContainerEl.querySelector(productId) : this.otherContainerEl;
            if (target) {
                const productPosition = target.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: productPosition - offset,
                    behavior: 'smooth'
                });
            }
        },

        goToGroupPage(group) {
            window.location.href = `/pages/test-wishlist-group?groupId=${encodeURIComponent(group)}`;
        },

        isModalOpen(modalName) {
            return this.modals[modalName];
        },

        openModal(modalName) {
            this.modals[modalName] = true;
        },

        closeModal(modalName) {
            this.modals[modalName] = false;
        },

        getProductAttributes(title) {
            const productTitleLower = title.toLowerCase();
            let background = '';
            let state = 'other';
            let type = 'other';
            let color = 'no';
            if (productTitleLower.includes('original') || productTitleLower.includes('originale')) {
                background = 'bg-red-800';
                state = 'original';
            } else if (productTitleLower.includes('compliant')) {
                background = 'bg-gray-800';
                state = 'compliant';
            } else if (productTitleLower.includes('recycled') || productTitleLower.includes('refurbished') || productTitleLower.includes('remis') || productTitleLower.includes('remise')) {
                background = 'bg-green-800';
                state = 'refurbished';
            } else if (productTitleLower.includes('unboxed') || productTitleLower.includes('hors') || productTitleLower.includes('économique') || productTitleLower.includes('economic')) {
                background = 'bg-black';
                state = 'unboxed';
            } else if (productTitleLower.includes('compatible')) {
                background = 'bg-yellow-500';
                state = 'compatible';
            }
            if (productTitleLower.includes('cartouches') || productTitleLower.includes('cartridges') || productTitleLower.includes('cartouche') || productTitleLower.includes('cartridge')) {
                type = 'cartridge';
            } else if (productTitleLower.includes('micr')) {
                type = 'micr';
            } else if (productTitleLower.includes('drum') || productTitleLower.includes('tambour')) {
                type = 'drum';
            } else if (productTitleLower.includes('lexmark') && productTitleLower.includes('compliant')) {
                type = 'lexmark-compliant';
            } else if (productTitleLower.includes('lexmark') && productTitleLower.includes('elevate')) {
                type = 'lexmark-elevate';
            } else if (productTitleLower.includes('tête') || productTitleLower.includes('head')) {
                type = 'head';
            } else if (productTitleLower.includes('printer') || productTitleLower.includes('imprimante') || productTitleLower.includes('printers') || productTitleLower.includes('imprimantes')) {
                type = 'printer';
            }
            if (productTitleLower.includes('noir') || productTitleLower.includes('black')) {
                color = "black";
            } else if (productTitleLower.includes('couleur') || productTitleLower.includes('color')) {
                color = "color";
            } else if (productTitleLower.includes('cyan')) {
                color = "cyan";
            } else if (productTitleLower.includes('magenta')) {
                color = "magenta";
            } else if (productTitleLower.includes('jaune') || productTitleLower.includes('yellow')) {
                color = "yellow";
            }
            return { type, state, color, background };
        },

        sortFavoritesByGroup(favorites) {
            const typeOrder = ['cartridge', 'micr', 'head', 'drum', 'printer', 'other'];
            const stateOrder = ['original', 'compliant', 'unboxed', 'refurbished', 'compatible', 'other'];
            const grouped = new Map();
            favorites.forEach((product) => {
                if (!product.productHandle) return;
                const { type, state } = this.getProductAttributes(product.productHandle);
                const key = `${type}_${state}`;
                if (!grouped.has(key)) {
                    grouped.set(key, []);
                }
                grouped.get(key).push(product);
            });
            const sortedGroups = new Map();
            Array.from(grouped.keys())
                .sort((a, b) => {
                    const [typeA, stateA] = a.split('_');
                    const [typeB, stateB] = b.split('_');
                    const typeComparison = typeOrder.indexOf(typeA) - typeOrder.indexOf(typeB);
                    if (typeComparison !== 0) return typeComparison;
                    return stateOrder.indexOf(stateA) - stateOrder.indexOf(stateB);
                })
                .forEach((key) => {
                    const products = grouped.get(key);
                    sortedGroups.set(key, products);
                });
            return sortedGroups;
        },

 groupAndSort(container) {
    const products = Array.from(container.children);
    function getClassValue(product, classPrefix) {
        const classList = Array.from(product.classList);
        const matchedClass = classList.find((className) => className.startsWith(classPrefix));
        return matchedClass ? matchedClass.split('_').slice(1).join('_') : 'other';
    }
    const productOrder = ['cartridge', 'micr', 'head', 'drum', 'printer', 'other'];
    const typeOrder = ['original', 'compliant', 'unboxed', 'refurbished', 'compatible', 'other'];
    const groupedByProductType = products.reduce((groups, product) => {
        const type = getClassValue(product, 'product-type');
        if (!groups[type]) groups[type] = [];
        groups[type].push(product);
        return groups;
    }, {});
    const sortedProductTypes = Object.keys(groupedByProductType).sort((a, b) => {
        return productOrder.indexOf(a) - productOrder.indexOf(b);
    });

    sortedProductTypes.forEach((productType) => {
        const groupedByState = groupedByProductType[productType].reduce((typeGroups, product) => {
            const type = getClassValue(product, 'type');
            if (!typeGroups[type]) typeGroups[type] = [];
            typeGroups[type].push(product);
            return typeGroups;
        }, {});
        const sortedTypes = Object.keys(groupedByState).sort((a, b) => {
            return typeOrder.indexOf(a) - typeOrder.indexOf(b);
        });
        sortedTypes.forEach((type) => {
            const sortedByColor = groupedByState[type].sort((a, b) => {
                const colorA = getClassValue(a, 'color');
                console.log(colorA)
                const colorB = getClassValue(b, 'color');
                console.log(colorB)

                return compareColors(colorA, colorB);
            });

            console.log(sortedByColor)
            const groupTitle = createGroupTitle(productType, type);
            const groupContainer = document.createElement('div');
            groupContainer.classList.add('group-container', 'flex', 'flex-col', 'gap-4', `${productType}-${type}`);
            const titleElement = document.createElement('h3');
            titleElement.classList.add('group-title', 'rounded', 'bg-white', 'uppercase', 'p-8');
            titleElement.textContent = groupTitle;
            groupContainer.appendChild(titleElement);
            titleElement.addEventListener('click', () => {
                const input1 = document.getElementById(`type-${type}`);
                const input2 = document.getElementById(`product-type-${productType}`);

                // Décocher tous les inputs dans les groupes "type-filter" et "product-type-filter"
                document.querySelectorAll('.type-filter:checked, .product-type-filter:checked, color-filter:checked').forEach(input => {
                    input.checked = false;
                    input.dispatchEvent(new Event('change')); // déclenchement des listeners si nécessaires
                });

                // Cocher les deux souhaités
                if (input1) {
                    input1.checked = true;
                    input1.dispatchEvent(new Event('change'));
                }
                if (input2) {
                    input2.checked = true;
                    input2.dispatchEvent(new Event('change'));
                }
            });

            sortedByColor.forEach((product) => groupContainer.appendChild(product));
            container.appendChild(groupContainer);
        });
    });
},

        async createGroup() {
            if (!this.groupToAdd) return console.log('Le nom du groupe est vide');
            const result = await createGroup(this.customerId, this.groupToAdd);
            if (result.success) {
                this.groups.push(this.groupToAdd);
                this.favorites.set(this.groupToAdd, new Map());
                this.groupToAdd = '';
            } else {
                console.log('Erreur lors de la création du groupe');
            }
        },

        async deleteGroup(groupId) {
            if (!groupId) return console.log('Le nom du groupe est vide');
            const result = await deleteGroup(this.customerId, groupId);
            if (result.success) {
                this.groups = this.groups.filter(group => group !== groupId);
                this.favorites.delete(groupId);
            } else {
                console.log('Erreur lors de la suppression du groupe');
            }
        },

        isFavorite(productId) {
            if (this.groupId) {
                const groupFavorites = this.favorites.get(this.groupId);
                if (groupFavorites) {
                    return Array.from(groupFavorites.values()).some(favoritesArray =>
                        favoritesArray.some(fav => fav.productId === String(productId))
                    );
                }
                return false;
            } else {
                return Array.from(this.favorites.values()).some(group =>
                    Array.from(group.values()).some(favoritesArray =>
                        favoritesArray.some(fav => fav.productId === String(productId))
                    )
                );
            }
        },

        async addToWishlistConfirmation() {
            const groupId = this.selectedGroup;
            if (!groupId) return console.log('Aucun groupe sélectionné ou créé');
            await this.addToWishlist(groupId, this.productId, this.productHandle, this.brand, this.model);
            this.closeModal("addFavorite");
        },

        async addToWishlist(group, productId, productHandle, brand, model) {
            const groupId = group ?? this.groupId;
            const result = await addToWishlist(this.customerId, groupId, productId, productHandle, brand, model);
            if (result.success) {
                const product = await this.fetchProductData(productHandle);
                const favorite = { productId, productHandle, brand, model, product };
                const { type, state } = this.getProductAttributes(product.title);
                const key = `${type}_${state}`;
                if (!this.favorites.has(groupId)) {
                    this.favorites.set(groupId, new Map([[key, [favorite]]]));
                    this.groups.push(groupId);
                    localStorage.setItem('favorites-groups', JSON.stringify(this.groups));
                    localStorage.setItem(`favorites-${groupId}`, JSON.stringify(Array.from(this.favorites.get(groupId).entries())));
                } else {
                    const groupFavorites = this.favorites.get(groupId);
                    if (!groupFavorites.has(key)) {
                        groupFavorites.set(key, [favorite]);
                    } else {
                        const existingFavorites = groupFavorites.get(key);
                        if (!existingFavorites.some(fav => fav.productId === productId)) {
                            existingFavorites.push(favorite);
                        }
                    }
                    localStorage.setItem(`favorites-${groupId}`, JSON.stringify(Array.from(groupFavorites.entries())));
                }
                if (this.groupId) {
                    const productEl = await this.renderProduct(product, type, state);
                    const typeOrder = ['cartridge', 'micr', 'head', 'drum', 'printer', 'other'];
                    const stateOrder = ['original', 'compliant', 'unboxed', 'refurbished', 'compatible', 'other'];
                    const groupSelector = `.group-container.${type}-${state}`;
                    let groupContainer = container.querySelector(groupSelector);
                    if (!groupContainer) {
                        const groupTitle = createGroupTitle(type, state);
                        groupContainer = document.createElement('div');
                        groupContainer.classList.add('group-container', 'flex', 'flex-col', 'gap-4', `${type}-${state}`);
                        const titleElement = document.createElement('h3');
                        titleElement.classList.add('group-title', 'rounded', 'bg-white', 'uppercase', 'p-8');
                        titleElement.textContent = groupTitle;
                        groupContainer.appendChild(titleElement);
                        const existingGroups = Array.from(container.querySelectorAll('.group-container'));
                        const insertIndex = existingGroups.findIndex((group) => {
                            const [existingType, existingState] = group.classList.value.match(/(\w+)-(\w+)$/).slice(1, 3);
                            return (
                                typeOrder.indexOf(type) < typeOrder.indexOf(existingType) ||
                                (typeOrder.indexOf(type) === typeOrder.indexOf(existingType) &&
                                    stateOrder.indexOf(state) < stateOrder.indexOf(existingState))
                            );
                        });
                        if (insertIndex === -1) {
                            container.appendChild(groupContainer);
                        } else {
                            container.insertBefore(groupContainer, existingGroups[insertIndex]);
                        }
                    }
                    const productElement = document.createElement('div');
                    productElement.innerHTML = productEl;
                    groupContainer.appendChild(productElement);
                    this.scrollToProduct()
                }
            }
        },

        async removeFromWishlist(productId) {
            let result;
            if (this.groupId) {
                result = await removeFromGroup(this.customerId, this.groupId, productId);
                if (result.success) {
                    const groupFavorites = this.favorites.get(this.groupId);
                    if (groupFavorites) {
                        groupFavorites.forEach((favorites, key) => {
                            const updatedFavorites = favorites.filter(fav => fav.productId !== productId);
                            this.favorites.get(this.groupId).set(key, updatedFavorites);
                        });
                    }
                    let productEl;
                    let productElToRemove;
                    productEl = this.printerContainerEl.querySelector(`#ProductInfo-${productId}`);
                    if (productEl) {
                        productElToRemove = productEl.closest('.group-compatible-container');
                        productElToRemove.remove();
                        this.navigationLinks = this.navigationLinks.filter(link => link.target !== `#ProductInfo-${productId}`);
                    } else {
                        productElToRemove = this.otherContainerEl.querySelector(`#ProductInfo-${productId}`);
                    }
                    productElToRemove.remove();
                    this.scrollToProduct()
                }
            } else {
                result = await removeFromAllGroups(this.customerId, productId);
                if (result.success) {
                    this.favorites.forEach((groupFavorites, groupId) => {
                        groupFavorites.forEach((favorites, key) => {
                            const updatedFavorites = favorites.filter(fav => fav.productId !== productId);
                            this.favorites.get(groupId).set(key, updatedFavorites);
                        });
                    });
                }
            }
        },

        async toggleFavorite(productId, productHandle, brand, model, group) {
            group = "default"

            console.log(group)
            console.log("toggle")
            const isFavorite = this.isFavorite(productId);
            if (isFavorite) {
                await this.removeFromWishlist(productId);
            } else {
                if (group) {
                    await this.addToWishlist(group, productId, productHandle, brand, model)

                } else {
                    if (this.group) {
                        await this.addToWishlist(null, productId, productHandle, brand, model)
                    } else {
                        this.productId = productId;
                        this.productHandle = productHandle;
                        this.brand = brand;
                        this.model = model;
                        this.openModal("addFavorite");
                    }
                }
            }
        },

        async renderProduct(favorite, type, state) {
            const colorOrder = ['black', 'cyan', 'magenta', 'yellow', 'color', 'other'];
            if (favorite) {
                const { color } = this.getProductAttributes(favorite.title);
                // const view = (favorite.product_type?.toLowerCase() === 'printer' && favorite.variants[0]?.price === "0.00")
                //     ? this.compatibleView
                //     : this.favoritesView;
                const view = (favorite.product_type?.toLowerCase() === 'printer')
                    ? this.compatibleView
                    : this.favoritesView;
                const container = view === this.compatibleView
                    ? this.printerContainerEl
                    : this.otherContainerEl.querySelector(`.${type}-${state}`);
                const url = view === this.compatibleView
                    ? `/search?q=${extractModelValue(favorite.tags)}&type=product&unavailable_products=show&sort_by=relevance&view=${view}`
                    : `/search?q=${favorite.title}&unavailable_products=show&sort_by=relevance&type=product&view=${view}`;
                const response = await fetch(url);
                const html = await response.text();
                const result = html.split("<!-- resultat -->")[1];
                if (view === this.compatibleView) {
                    const productId = `#ProductInfo-${favorite.id}`;
                    this.navigationLinks.push({
                        target: productId,
                        title: favorite.title
                    })
                    this.navigationLinks = this.navigationLinks
                        .map(link => ({
                            ...link,
                            title: link.title.replace(/Imprimante|Printer/gi, '').trim()
                        }))
                        .sort((a, b) => a.title.localeCompare(b.title));
                    container.insertAdjacentHTML('beforeend', result);
                    const compatibleId = `#ProductCompatible-${favorite.id}`;
                    const compatibleProductsEl = container.querySelector(`${compatibleId}.sorted-products-container`)
                    this.groupAndSort(compatibleProductsEl)
                } else {
                    const existingProducts = Array.from(container.children);
                    let insertPosition = existingProducts.findIndex((existingProduct) => {
                        const existingColor = this.getProductAttributes(existingProduct.textContent).color;
                        return colorOrder.indexOf(existingColor) > colorOrder.indexOf(color);
                    });
                    if (insertPosition === -1) {
                        container.insertAdjacentHTML('beforeend', result);
                    } else {
                        existingProducts[insertPosition].insertAdjacentHTML('beforebegin', result);
                    }
                }
            }
        },

        async renderContainer() {
            const groupFavorites = this.favorites.get(this.groupId);
            if (groupFavorites) {
                const renderPromises = [];

                for (const [key, products] of groupFavorites) {
                    const [type, state] = key.split('_');
                    const groupTitle = createGroupTitle(type, state);
                    const groupContainer = document.createElement('div');
                    groupContainer.classList.add('group-container', 'flex', 'flex-col', 'gap-4', `${type}-${state}`);
                    const titleElement = document.createElement('h3');
                    titleElement.classList.add('group-title', 'rounded', 'bg-white', 'uppercase', 'p-8', 'hidden');
                    titleElement.textContent = groupTitle;
                    groupContainer.appendChild(titleElement);
                    this.otherContainerEl.appendChild(groupContainer);
                    for (const favorite of products) {
                        const renderPromise = this.renderProduct(favorite.product, type, state);
                        renderPromises.push(renderPromise);
                    }
                }
                await Promise.all(renderPromises);

                // Après que toutes les promesses de renderProduct soient terminées, on vérifie les produits favoris
                this.checkFavoriteProducts();
            } else {
                console.log('Aucun favori trouvé pour ce groupe.');
            }
        },

        async fetchProductData(productId) {
            try {
                const response = await fetch(`/products/${productId}.json`);
                if (!response.ok) {
                    console.error(`Erreur HTTP: ${response.statusText}`);
                    return null;
                }
                const text = await response.text();
                if (!text) {
                    console.error(`Réponse vide pour le produit ${productId}`);
                    return null;
                }
                const data = JSON.parse(text);
                return data.product;
            } catch (error) {
                console.error(`Erreur lors de la récupération des données du produit ${productId}: `, error.message);
                return null;
            }
        },

        async fetchData(data) {
            const promises = data.map(async (favorite) => {
                if (favorite.productHandle) {
                    const productData = await this.fetchProductData(favorite.productHandle);
                    if (productData) {
                        return {
                            ...favorite,
                            product: productData
                        };
                    }
                }
                return null;
            });
            const favoritesWithProductData = (await Promise.all(promises)).filter(item => item !== null);
            return favoritesWithProductData;
        },

        async initGroup(group) {
            const groupId = group ?? this.groupId;
            const result = await getGroupFavorites(this.customerId, groupId);
            if (result.success) {
                const data = await this.fetchData(result.favorites);
                const sortedData = this.sortFavoritesByGroup(data);
                this.favorites.set(groupId, sortedData);
                localStorage.setItem(`favorites-${groupId}`, JSON.stringify(Array.from(this.favorites.get(groupId).entries())));
                if (this.groupId) {
                    await this.renderContainer();
                    // this.checkFavoriteProducts();
                }
            }
        },

        checkFavoriteProducts() {
            // Vérification après le rendu des containers
            const groupContainers = this.otherContainerEl.querySelectorAll('.group-container');

            groupContainers.forEach(groupContainer => {
                const groupTitle = groupContainer.querySelector('.group-title');
                const hasFavoriteProduct = groupContainer.querySelector('.favorite-product');


                // Si un produit "favorite-product" est trouvé, on retire la classe "hidden" du titre
                if (hasFavoriteProduct) {
                    groupTitle.classList.remove('hidden');
                }
            });
        },

        async initGroups() {
            const result = await getGroups(this.customerId, this.email, this.name, this.phone);
            if (result.success) {
                this.groups = result.groups;
                localStorage.setItem('favorites-groups', JSON.stringify(this.groups));
                console.log("Groupes récupérés depuis l'API et stockés dans localStorage", this.groups);
            }
        },

        async initAll() {
            let favorites = JSON.parse(localStorage.getItem('favorites'));
            if (favorites) {
                this.favorites = favorites;
                console.log("Favoris récupérés depuis localStorage", this.favorites);
            } else {
                await this.initGroups();
                for (let groupId of this.groups) {
                    await this.initGroup(groupId);
                }
                this.groupId = null
            }
        },

        async init() {
            if (currentPage.includes('wishlist-group')) {
                console.log('wishlist-group')
                if (this.checkAuth() && this.groupId) await this.initGroup();
            } else if (currentPage.includes('wishlist')) {
                console.log('wishlist-group')
                if (this.checkAuth()) await this.initGroups();
            } else {
                console.log('no-wishlist')
                if (this.checkAuth()) await this.initAll();
            }
        },
    });
});

function extractModelValue(tags) {
    if (!tags) return null;
    const tagsArray = tags.split(', ').map(tag => tag.trim());
    const modelTag = tagsArray.find(tag => tag.startsWith('model_'));
    return modelTag ? modelTag : null;
}

function createGroupTitle(type, state) {
    const typeLabels = {
        cartridge: 'Cartridge',
        micr: 'MICR',
        head: "Print head",
        drum: "Drum"
    };
    const stateLabels = {
        original: 'Original',
        compliant: 'Compliant',
        unboxed: 'Unboxed',
        refurbished: 'Refurbished',
        compatible: 'Compatible'
    };
    return `${stateLabels[state] || ''}  ${typeLabels[type] || 'Other'} `;
}

function compareColors(colorA, colorB) {
    const colorOrder = ['noir', 'black', 'couleur', 'color', 'cyan', 'magenta', 'jaune', 'yellow', 'no'];
    const indexA = colorOrder.indexOf(colorA.toLowerCase());
    const indexB = colorOrder.indexOf(colorB.toLowerCase());
    return indexA - indexB;
}
